<script>
	module.exports = {
		props: ['article', 'route-context'],
		components: {
			'book-of-knowledge-tab': require('components/routes/student-workspace/book-of-knowledge-tab.vue').default
		},
		data: function () {
			return {
				demoText:
					'I learned that the Mississippi River is the longest river in North America.\n\nIt is home to more than 300 different types of animals.\n\nThe name "Mississippi" is from a Native American word that means "big river."'
			};
		}
	};
</script>
<template>
	<div class="row margin-bottom-large">
		<div class="large-8 columns padding-top-medium">
			<p>The Book of Knowledge is where students will write down things they have learned and want to remember from an article.</p>
			<p>Example:</p>
			<div class="site-student-demo">
				<header class="main-header -book-of-knowledge">
					<div class="wrapper">
						<h1
							class="main-header-title"
							style="float: none">
							Book of Knowledge
						</h1>
					</div>
				</header>
				<book-of-knowledge-tab
					is-demo
					v-bind:demo-text="demoText"></book-of-knowledge-tab>
			</div>
		</div>
		<div class="large-4 columns print-hidden">
			<article-aside
				v-bind:product="article"
				v-bind:article="article"
				v-bind:search-query-string="routeContext.parsedPath.getQueryParam('search')"></article-aside>
		</div>
	</div>
</template>
<style lang="sass" scoped>
	@import 'config/colors';
	.site-student-demo {
		box-shadow: 0 5px 10px rgba($c-black, .25);
		border: 1px solid $c-grey;
	}
</style>
